import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import { openMenu, closeMenu, open_menu_state, convertDateToDdMmYyyy } from '@/function/function.js';

import { cca_config } from '@/config'; 

export default {
    name: 'valider-paiement-all',
    components: {},
    props: ["passedConsult"],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            date_facture: '',

            today_date: this.date_function(),
            ref_bon: '',
            display_all_loading: true,
            save_loading: false,
            loadingAnalyse: false,
            loadingExamen: false,
            is_savable: true,
            is_printable: false,
            idUser: 1,
            vm_state: open_menu_state,
            operation_saved: null,
            all_soins: null,
            soins: [],
            box1: 0,
            box2: 1,
            box3: 1,
            operation_selected: null,
            somme_encaisse: 0,
            total_analyse_restant: 0,
            analyse_to_pay_id: 0,
            analyse_to_pay_montant: 0,
            carnets: [],
            qte_medoc: [],
            index_medicament_selected: null,

            // Determine s'il y a eu un paiement déjà effectué
            is_paid_before: false, //  Mettre à false par defaut
            analyse_checked: [],
            prescription_checked: [],
            consult_back: null
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return (this.consultation) ? this.consultation.patient : null
        },
        consultation() {
            return this.consult_back
        },
        analyses() {
            return this.$store.getters["analyses_for_consult"]
        },
        bulletin_id() {
            return this.$store.getters["analyses_for_consult"].id
        },
        prescription() {
            return this.$store.getters["prescriptions_pharmacie"]
        },
        prix_carnet() {
            let total = 0;
            this.carnets.forEach((element) => {
                total += parseInt(element.montant)
            });

            return total;
        },
        sous_total_prescription: {
            get: function() {
                let total = 0;

                // ************** ANCIENNE METHODE SANS LES CHECKBOXES
                // if (this.prescription) {
                //     this.prescription.forEach((data, index) => {

                //         // calculer le prix
                //         let prix = 0
                //         prix = parseInt(this.qte_medoc[index]) * parseInt(data.prix)
                //         if (prix > 0)
                //             total += prix;
                //     })
                // }
                // ************** ANCIENNE METHODE SANS LES CHECKBOXES

                if (this.prescription_checked) {
                    this.prescription_checked.forEach(data => {
                        // calculer le prix
                        let prix = 0
                            // console.log('dataaaaaaaaaaaaaaaa', this.qte_medoc)
                        let i = this.prescription.indexOf(data);
                        prix = parseInt(this.qte_medoc[i]) * parseInt(data.prix)
                        if (prix > 0)
                            total += prix;
                    })
                }

                return parseInt(total);
            }
        },
        total_prescription_restant() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data) => {

                    // calculer le prix
                    let prix = 0
                    prix = parseInt((parseInt(data.quantite) - parseInt(data.quantite_achat)) * parseInt(data.prix))
                    total += prix;

                })
            }
            return parseInt(total);
        },
        total_prescription() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data) => {
                    // calculer le prix
                    let prix = 0
                    prix = parseInt(parseInt(data.quantite) * parseInt(data.prix))
                    total += prix;

                })
            }
            return parseInt(total);
        },
        total_analyse() {
            let total = 0;
            // this.total_analyse_restant = 0;
            if (this.analyses) {
                if (this.analyses.length > 0) {
                    this.analyses.forEach(data => {
                        let prix_analyse = 0
                        prix_analyse = parseInt(data.analyse.prix)
                        total += prix_analyse;
                        // if (!data.traite || data.traite == 0) {
                        //     this.total_analyse_restant += parseInt(data.analyse.prix)
                        // }
                    })
                }
            }
            return parseInt(total);
        },
        total_soins() {
            if (this.soins)
                return parseInt(this.soins.acte_total + this.soins.consommable_total + this.soins.injectable_total)
            else
                return 0
        },
        total_analyse_assure() {
            // if (this.patient && this.patient.carte_assurance) {
            //     return Math.round((this.total_analyse * (100 - this.patient.carte_assurance.ticket_moderateur)) / 100)
            // } else {
            //     return this.total_analyse
            // }
            return parseInt(this.total_analyse)
        },
        total() {
            if (this.consultation) {
                // if (this.consultation.with_carnet == 1 || this.consultation.with_carnet)
                //     return parseInt(this.consultation.tarif_consultation.prix) + parseInt(this.prix_carnet) + parseInt(this.total_analyse + this.total_soins) + this.total_prescription;
                // else
                //     return parseInt(this.consultation.tarif_consultation.prix) + parseInt(this.total_analyse + this.total_soins) + this.total_prescription;

                return parseInt(this.consultation.tarif_consultation.prix) + parseInt(this.prix_carnet) + parseInt(this.total_analyse + this.total_soins) + this.total_prescription;
            } else return 0;
        },
        partAssureur() {
            if (this.patient && this.patient.carte_assurance) {
                return Math.round((this.total * this.patient.carte_assurance.ticket_moderateur) / 100)
            } else {
                return 0;
            }
        },
        partAssure() {
            if (this.patient && this.patient.carte_assurance) {
                return Math.round((this.total * (100 - this.patient.carte_assurance.ticket_moderateur)) / 100)
            } else {
                return this.total
            }
        },

        /**
         * Recupère l'ID des jours programmés pour les conduites à tenir
         * @returns 
         */
        jourCats() {
            return this.$store.getters['jour_cats'];
        },
    },
    // watch: {
    //     qte_medoc: {
    //         handler() {
    //             console.log("deep", this.qte_medoc)
    //         },
    //         deep: true
    //     },
    // },
    mounted() {
        this.date_facture = convertDateToDdMmYyyy.convertDate(new Date());

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        this.$store.dispatch('getTypesForConsultation', this.passedConsult).then((response) => {
            this.display_all_loading = false;
            this.consult_back = response
            $('.p-content').fadeIn();

            //recuperer les carnets eventuellements achetés
            this.$store.dispatch("getCarnetsDetailsPerOperation", response.operation_id).then((response) => {
                // console.log("carnnnn", response)
                this.carnets = response;
            })

        });

        this.$store.dispatch('getAnalysesForConsult', { consultation_id: this.passedConsult, bought: 0 }).then((response) => {
            this.total_analyse;
            // *** loop the response to get the cheboxes checked by default
            this.total_analyse_restant = 0;
            response.forEach(element => {
                if (!element.traite || element.traite == 0) {
                    this.analyse_checked.push(element)
                    this.total_analyse_restant += parseInt(element.analyse.prix)
                }
            });
            // *** end loop the response to get the cheboxes checked by default

            if (this.total_analyse_restant == 0) {
                this.box3 = 0
            }
        })

        //recuperer les prescriptions
        this.$store.dispatch('getPrescriptionsPharmacie', { consultation_id: this.passedConsult, bought: 0 }).then(() => {
            // console.log('les prescriptions', this.prescription)

            // enregistrer la liste des quantités et initialiser le checkbox correspondant
            this.prescription.forEach(data => {
                this.qte_medoc.push(data.quantite - data.quantite_achat);
                this.prescription_checked.push(data)
                    // this.qte_medoc.push(data.quantite);
            })
        })

        //looping soins object 
        this.$store.dispatch('getSoinsEnCoursByConsultation', { consultation_id: this.passedConsult, soins_state: 0 }).then((response) => {
            console.log("SSINS: ",response[0])
            this.soins = response[0]
            this.$store.dispatch('getCatJourID', this.passedConsult);
        })

    },
    methods: {
        date_function: function() {
            let date = new Date()
                // let expiration_d = new Date()
                // expiration_d.setDate(date.getDate() + 15)

            let today_month = date.getMonth() + 1
                // let expir_month = expiration_d.getMonth() + 1

            this.today_date = date.getDate() + '/' + today_month + '/' + date.getFullYear()
                // this.expiration_date = expiration_d.getDate() + '/' + expir_month + '/' + expiration_d.getFullYear()

            this.ref_bon = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds() + '/' + today_month + '/' + date.getDate()
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        /**
         * Désactiver / activer un jour de conduite à tenir
         * @param {*} selector 
         */
        jChange(selector, id) {
            console.log('index', selector)
            console.log('id', id)
            let j_deactivate = document.getElementById(selector);
            let set_param = {}

            if (j_deactivate.checked) {
                set_param = {
                    "jour_id": j_deactivate.value,
                    "etat": 0
                }

            } else {
                set_param = {
                    "jour_id": parseInt(j_deactivate.value),
                    "etat": 1
                }
            }

            this.$store.dispatch('deactiveJourCat', set_param).then(() => {
                this.refreshCAT()
            })


        },

        refreshCAT() {
            this.$store.dispatch('getSoinsEnCoursByConsultation', { consultation_id: this.passedConsult, soins_state: 0 }).then((response) => {
                this.soins = response[0]
                console.log("NEW CAT: ", response)
            });
        },

        updateAnalyseSelection() {
            let total_check = 0;
            this.analyse_checked.forEach(data => {
                let prix_analyse = 0
                prix_analyse = parseInt(data.analyse.prix)
                total_check += prix_analyse;
            })

            this.total_analyse_restant = total_check;
        },

        updatePrescriptionSelection() {},

        /**
         * Valider / Différer un paiement
         * @param {*} differe 
         * @param {*} confirm_selector 
         */
        submitValider(differe, confirm_selector) {

            console.log()
            this.save_loading = true;
            let confirm = document.getElementById(confirm_selector);
            let err = 0;
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé avoir encaissé le montant
                $('.err-msg').fadeIn(500)
                err++;
                this.save_loading = false;
            }

            // +++++++++      Si confirmer via le checkbox, on enregistre    ++++++++++
            if (err == 0) {
                // if (this.partAssure > 0) {
                //On enregistre l'opération 

                // let comptabilise = true;
                // if (differe == 1) {
                //     comptabilise = false;
                // }

                switch (this.operation_selected) {
                    case "box1":
                        // consultation
                        break;

                    case "soins":
                        // Soins
                        this.saveSoinsDatas(differe)
                        break;

                    case "analyses":
                        // Analyse
                        this.saveAnalyseDatas(differe)
                        break;

                    case "prescri":
                        // Prescriptions de médicament
                        this.savePrescriptionsDatas(differe)
                        break;
                    default:
                        break;
                }
            }

        },
        saveAnalyseDatas(comptabilise) {
            // let montant_to_save = 0;

            // **************ancienne méthode avec la validation par ligne
            // dans le cas ou c'est une analyse qui est payé
            // if (this.analyse_to_pay_id > 0 && this.analyse_to_pay_montant > 0) {
            //     montant_to_save = this.analyse_to_pay_montant

            // } else {
            //     // ici c'est la totalité ou un groupe de message
            //     montant_to_save = this.total_analyse_restant
            // }
            // ************** fin ancienne méthode avec la validation par ligne

            // on parcour les analyses pour enregistrement
            this.analyse_checked.forEach((analyse) => {


                // enregistrement de l'operation en caisse
                // montant_to_save = this.total_analyse_restant
                let operation_data = {
                    libelle: 'Analyse effectuée',
                    montant: analyse.analyse.prix,
                    type_operation: 1,
                    comptabilise: comptabilise,
                    user_id: this.user_id,
                    utilisateur_id: this.patient.id,
                    type_utilisateur: 1,
                    destination: this.compte_id,
                    categorie_operation_id: 2
                };

                this.$store.dispatch("storeOperation", operation_data).then((response) => {
                    this.operation_saved = this.$store.getters['operation']
                        ////ON ENREGISTRE ALORS LE COMPTE OPERATION
                        // let compte = 1 // le compte caisse
                    let operation = response.id

                    // ON FAIT UN UPDATE DE L'analyse en question
                    let analyse_to_send = [];
                    analyse_to_send.push(analyse)

                    this.$store.dispatch("updateBulAnalyse", {
                        consult_id: this.passedConsult,
                        operation_id: operation,
                        analyses_checked: analyse_to_send,
                        analyse_selected_id: this.analyse_to_pay_id
                    }).then(() => {
                        // console.log('analyse updated', response)
                    })
                })
            })
            $('.modal').modal('hide');
            this.doAfterSuccess(comptabilise)
            this.box3 = 0;
            this.$forceUpdate();
        },
        saveSoinsDatas(comptabilise) {

            // get articles to send to stock
            let articles = [];

            this.soins.consommables.forEach(element => {
                articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
            });
            this.soins.injectables.forEach(element => {
                articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
            });


            let for_stock = {
                    "patient": this.patient.nom + " " + this.patient.prenoms,
                    "prescripteur": "interne",
                    "articles": articles
                }
                //ON FAIT UN UPDATE EN STOCK DES PRODUITS
            this.$store.dispatch("postVenteSoinsEffectues", for_stock).then((response) => {

                if (response.reponse == false) {
                    this.doAfterErrorVente(response.erreur)

                } else {
                    // ON ENREGISTRE LA COMPTABILITE

                    // Comptabilisation
                    if (comptabilise) {
                        let operation_data = {
                            libelle: 'Soins effectués',
                            montant: this.total_soins,
                            type_operation: 1,
                            comptabilise: comptabilise,
                            user_id: this.user_id,
                            utilisateur_id: this.patient.id,
                            type_utilisateur: 1,
                            destination: this.compte_id,
                            categorie_operation_id: 4
                        };
                        this.$store.dispatch("storeOperation", operation_data).then((response_operation) => {
                            console.log('operation saved', response_operation)

                            // ON FAIT UN UPDATE COTE CLINIQUE
                            let operation_to_send = 0;
                            if (comptabilise) {
                                operation_to_send = 1
                            } else {
                                operation_to_send = 2
                            }

                            let jour_checked = [];
                            $('input[name="jour_checked"]:checked').each(function() {
                                jour_checked.push(this.value)
                            });

                            this.$store.dispatch("sendStateSoinsValider", { id_consult: this.passedConsult, operation: operation_to_send, jours_selected: jour_checked }).then((rr) => {
                                console.log("SOINS STATES UPDATED", rr)
                                this.doAfterSuccess(comptabilise)
                                this.box2 = 0;
                            })
                        })

                    } else { // on ne comptabilise pas 

                        // ON FAIT UN UPDATE COTE CLINIQUE
                        let operation_to_send = 0;
                        if (comptabilise) {
                            operation_to_send = 1
                        } else {
                            operation_to_send = 2
                        }
                        let jour_checked = [];
                        $('input[name="jour_checked"]:checked').each(function() {
                            jour_checked.push(this.value)
                        });

                        this.$store.dispatch("sendStateSoinsValider", { id_consult: this.passedConsult, operation: operation_to_send, jours_selected: jour_checked }).then((rr) => {
                            console.log("SOINS STATES UPDATED", rr)
                            this.doAfterSuccess(comptabilise)
                            this.box2 = 0;
                        })

                    }

                }
            })
        },
        savePrescriptionsDatas(comptabilise) {
            let articles = [];
            //let montant_to_save = 0;

            //get prescriptions list
            let prescriptions_to_return = [];
            // dans le cas ou c'est une ligne de prescription

            if (this.index_medicament_selected >= 0) {

                articles.push({
                    article: this.prescription[this.index_medicament_selected].medicament_stock,
                    libelle: this.prescription[this.index_medicament_selected].medicament_libelle,
                    quantite: this.qte_medoc[this.index_medicament_selected],
                    posologie: this.prescription[this.index_medicament_selected].posologie
                })
                prescriptions_to_return.push({
                    id: this.prescription[this.index_medicament_selected].id,
                    quantite_achat: this.qte_medoc[this.index_medicament_selected],
                    posologie: this.prescription[this.index_medicament_selected].posologie
                })
            } else {

                // montant_to_save = this.total_analyse_restant
                this.prescription_checked.forEach(data => {

                    let index = this.prescription.indexOf(data);
                    //s'il reste des quantités à payer
                    if (data.quantite > data.quantite_achat) {
                        articles.push({
                            article: data.medicament_stock,
                            libelle: data.medicament_libelle,
                            quantite: this.qte_medoc[index],
                            posologie: data.posologie

                        });

                        prescriptions_to_return.push({
                            id: data.id,
                            quantite_achat: this.qte_medoc[index],
                            quantite_differe: (comptabilise) ? 0 : this.qte_medoc[index]
                        })
                    }
                    //sil n'en reste pas on ne  comptabilise pas
                })

            }

            // envoi en stock
            let for_stock = {
                    "patient": this.patient.nom + " " + this.patient.prenoms,
                    "prescripteur": "interne",
                    "articles": articles
                }
                //ON FAIT UN UPDATE EN STOCK DES PRODUITS

            this.$store.dispatch("postVenteSoinsEffectues", for_stock).then((response) => {
                console.log('retour Soins', response.reponse)
                if (response.reponse == false) {
                    this.doAfterErrorVente(response.erreur)

                } else {
                    // ON FAIT UN UPDATE COTE CLINIQUE
                    this.$store.dispatch("sendPrescriptionsAfterVente", {
                        idConsult: this.passedConsult,
                        ventes: prescriptions_to_return
                    }).then((response) => {
                        console.log("PRESCRIPTION AFTER VENTE", response)
                            // comptabilisation

                        if (comptabilise) {
                            let operation_data = {
                                libelle: 'Vente de médicaments',
                                montant: this.somme_encaisse,
                                type_operation: 1,
                                comptabilise: comptabilise,
                                user_id: this.user_id,
                                utilisateur_id: this.patient.id,
                                type_utilisateur: 1,
                                destination: this.compte_id,
                                categorie_operation_id: 5
                            };

                            this.$store.dispatch("storeOperation", operation_data).then((response) => {
                                console.log('operation saved', response)
                                this.doAfterSuccess(comptabilise)
                            })
                        } else {
                            this.doAfterSuccess(comptabilise);
                        }
                    })
                }
            })
        },
        doAfterSuccess(comptabilise) {
            $('.modal').modal('hide')
            if (comptabilise == false) {
                this.doSuccessMsg('L\'enregistrement a été fait. L\'encaissement a été différé');
            } else {
                this.doSuccessMsg('Enregistrement et encaissement effectués');
            }
            this.save_loading = false;
            this.is_printable = true;
            this.is_savable = false;
            this.$router.push({ path: '/dashboard' })
            confirm.checked = false
        },

        doAfterErrorVente(error) {
            this.save_loading = false;

            $('.modal').modal('hide')

            var message = ""
            error.forEach((element, index) => {
                if (index == error.length - 1) {
                    message = message + element.libelle

                } else {
                    message = message + element.libelle + " ,"
                }
            });


            this.$toasted.show('Certains articles sont indisponible :' + message, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            let to_print = "Veuillez choisir tous les éléments nécessaires pour l'enregistrement";
            if (msg)
                to_print = msg

            if (this.$toasted != null) this.$toasted.clear()

            this.$toasted.show(to_print, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        // controler la saisit des nombres de médicaments
        handleInput: function(value, index) {

            if (parseInt(value) > 0) { //si c'est un entier saisit
                // si la quantité saisit dépasse la quantité restante à acheter
                // mettre la quantité réglémentaire
                let quantite_restante_a_acheter = parseInt(this.prescription[index].quantite) - parseInt(this.prescription[index].quantite_achat)

                if (value > quantite_restante_a_acheter) {
                    this.doErrorMsg("Quantité saisie incorrecte");
                    // this.qte_medoc[index] = quantite_restante_a_acheter
                    this.$set(this.qte_medoc, index, quantite_restante_a_acheter)
                }
            } else {
                // si ce n'est pas un entier
                // this.qte_medoc[index] = 1
                // this.$set(this.qte_medoc, index, 1)
            }
        },

        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
            this.operation_selected = selector
        },
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Definit le type de facture à payer (Ex. Soin, Consultation...)
         * @param {*} type_facture 
         */
        setInvoiceType(type_facture, idSelected, mtSelected) {

            // console.log('aaaaaaaaaaaaaaa', this.analyse_checked);
            this.operation_selected = type_facture
            switch (type_facture) {
                case 'analyses':
                    if (idSelected > 0) {
                        this.analyse_to_pay_id = idSelected
                        this.analyse_to_pay_montant = mtSelected
                        this.somme_encaisse = mtSelected
                    } else {
                        this.somme_encaisse = this.total_analyse_restant
                        this.analyse_to_pay_id = 0
                        this.analyse_to_pay_montant = 0

                        if (this.total_analyse_restant == 0) this.doErrorMsg('Veuillez sélectionner des analyses à payer')
                    }
                    break;
                case 'soins':
                    this.somme_encaisse = this.total_soins
                    break;

                case 'prescri':
                    this.somme_encaisse = this.total_soins
                    if (idSelected >= 0) { // pour les paiements individuels
                        this.index_medicament_selected = idSelected
                        this.somme_encaisse = parseInt(this.qte_medoc[idSelected]) * parseInt(this.prescription[idSelected].prix)
                    } else { // pour le paiement en total
                        this.index_medicament_selected = -1;
                        this.somme_encaisse = this.sous_total_prescription
                    }
                    if (this.sous_total_prescription == 0) this.doErrorMsg('Veuillez sélectionner des médicaments à payer')
                    break;

                default:
                    break;
            }
        },


        printFacture() {
            this.$refs.facture_html2Pdf.generatePdf()
        },
        triggerSousTotal() {

        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'La caisse';
                let lome_le = cca_config.VILLE+', le ' + this.date_facture;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        }

    }
}